var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.modal_showing),expression:"!modal_showing"}],staticClass:"cookie_card",on:{"click":_vm.show_modal}},[_c('p',[_vm._v("Politika upotrebe kolačića")])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2932a58","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/CookiePolicyComponent.vue
// module id = 74
// module chunks = 1